(() => {
  const root = document.querySelector('.nr-section');
  if (!root || root.dataset.ready) return;

  const cards = [...root.querySelectorAll('.nr-card')];
  const filters = [...root.querySelectorAll('[data-review-filter]')];
  const search = root.querySelector('.nr-search input');
  const nav = root.querySelector('.nr-pagination');
  const prev = root.querySelector('[data-review-prev]');
  const next = root.querySelector('[data-review-next]');
  const pageLabel = root.querySelector('[data-review-page]');
  const results = root.querySelector('.nr-results');
  const empty = root.querySelector('.nr-empty');
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const texts = new Map(cards.map(card => [card, normalize(
    (card.querySelector('.nr-body')?.textContent || '') + ' ' +
    (card.querySelector('.nr-author')?.textContent || '')
  )]));
  const photoCards = new Set(cards.filter(card => card.querySelector('img')));
  const photoCount = root.querySelector('[data-review-filter="photos"] span');
  if (photoCount) photoCount.textContent = String(photoCards.size);
  const originalDisplay = new WeakMap();
  function setHidden(element, hidden) {
    if (!element) return;
    if (!originalDisplay.has(element)) {
      originalDisplay.set(element, [element.style.getPropertyValue('display'), element.style.getPropertyPriority('display')]);
    }
    element.hidden = hidden;
    const [display, priority] = originalDisplay.get(element);
    if (hidden) element.style.setProperty('display', 'none', 'important');
    else if (display) element.style.setProperty('display', display, priority);
    else element.style.removeProperty('display');
  }

  const size = 12;
  let mode = 'all';
  let limit = size;
  function render() {
    const query = normalize(search?.value.trim());
    const matches = cards.filter(card =>
      (mode !== 'photos' || photoCards.has(card)) && texts.get(card).includes(query)
    );
    const visible = new Set(matches.slice(0, limit));
    cards.forEach(card => setHidden(card, !visible.has(card)));
    const hasMore = matches.length > limit;
    setHidden(nav, !hasMore);
    setHidden(prev, true);
    setHidden(pageLabel, true);
    if (next) {
      next.textContent = 'Afficher plus d’avis';
      next.disabled = !hasMore;
      setHidden(next, !hasMore);
    }
    if (results) results.textContent = matches.length ? `1–${Math.min(limit, matches.length)} sur ${matches.length} avis` : '0 avis';
    setHidden(empty, matches.length !== 0);
  }

  filters.forEach(button => button.addEventListener('click', () => {
    mode = button.dataset.reviewFilter;
    limit = size;
    filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    render();
  }));
  search?.addEventListener('input', () => { limit = size; render(); });
  next?.addEventListener('click', () => { limit += size; render(); });

  const dialog = root.querySelector('.nr-lightbox');
  let opener;
  if (dialog) {
    root.querySelectorAll('[data-review-photo]').forEach(button => button.addEventListener('click', () => {
      const img = dialog.querySelector('img');
      if (!img || typeof dialog.showModal !== 'function') return;
      opener = button;
      img.src = button.dataset.reviewPhoto;
      img.alt = button.dataset.photoAlt || '';
      dialog.showModal();
    }));
    dialog.querySelector('.nr-close')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
  }

  render();
  const form = root.querySelector('form');
  root.querySelector('.nr-write')?.addEventListener('click', () => setTimeout(() => {
    form?.querySelector('input:not([type=hidden]),[role=status]')?.focus({ preventScroll: true });
  }, 100));
  const success = root.querySelector('.nr-form-success');
  if (success) {
    success.scrollIntoView({ block: 'center' });
    success.focus({ preventScroll: true });
  }
  window.addEventListener('load', () => {
    if (location.hash === '#avis') root.scrollIntoView({ block: 'start' });
  }, { once: true });
  root.dataset.ready = 'true';
})();
